import React from 'react';
import Video from '../components/Video';
import '../App.css';

function Home() {
    return (
        <div>
            <Video />
        </div>
    )
}

export default Home;
